import Vue from "vue";
import Vuex from "vuex";
import Web3 from 'web3';
import { getChainByCode, getDefaultTokenByChain } from "@/utils/chain";

Vue.use(Vuex);

const SoarState = {
  key: "SoarState",
  get: () => {
    const temp = localStorage.getItem(SoarState.key);
    return temp && JSON.parse(temp) || {};
  },
  set: () => {
    // const { account, chainCode, chainId, gasPrice, platform } = store.state;
    localStorage.setItem(
      SoarState.key,
      JSON.stringify({
        // account,
        // chainCode,
        // chainId,
        // gasPrice,
        // platform
      })
    );
  },
};

window.addEventListener("beforeunload", (e) => {
  SoarState.set();
});

window.addEventListener("load", () => {
  const { state } = store;
  const { rpcUrls } = state;
  if (rpcUrls && rpcUrls.length > 0) {
    Object.assign(state, "provider", new Web3(rpcUrls[0]));
  }
})

const store = new Vuex.Store({
  state: {
    platform: '',
    account: '',
    chainCode: '',
    platformList: [],

    spotList: [],
    perpList: [],
    pairSymbol: null,
    pairObj: {
      leverage: 20,
      symbol: ''
    },
    pay: 0,
    userPositions: [],
    userTrades:[],
    userOrders: [],

    orderbooks: [],
    trades: [],

    chainId: 56,
    wallet: "",
    connect: false,
    gasPrice: 5,
    provider: {},
    signer: null,
    nativeCurrency: null,

    ...SoarState.get(),
  },
  mutations: {
    SET_GASPRICE (state, payload) {
      state.gasPrice = payload;
    },
    SET_ACCOUNT (state, payload) {
      localStorage.setItem(`${state.platform.name}_account`, payload)
      state.account = payload;
    },
    SET_WALLET (state, payload) {
      state.wallet = payload;
      localStorage.setItem(`${state.platform.name}_wallet`, payload)
    },
    SET_SIGNER (state, payload) {
      state.signer = payload;
    },
    SET_CHAINCODE (state, payload) {
      state.chainCode = payload;
      localStorage.setItem(`${state.platform.name}_chain`, payload)

      const chain = getChainByCode(payload);
      if (chain) {
        const { chainId, rpcUrls } = chain;
        state.chainId = chainId;
        if (rpcUrls && rpcUrls.length) {
          state.provider = new Web3(rpcUrls[0]);
        }
      }
      SoarState.set();
    },
  },
  actions: {
    async FETCH_CONTRACT ({ commit, state }) {
      // const { abi, contract, approveContract } = await getContract(state.chainCode);
      // commit("SET_SWAP_ABI", abi);
      // commit("SET_SWAP_CONTRACT", contract);
      // commit("SET_SWAP_APPROVE_CONTRACT", approveContract);
    },
  },
  modules: {
    // market: marketModule
  },
});

export default store;
